// extracted by mini-css-extract-plugin
export default {"tictactoegame":"tictactoegame_baafa27b2ea618205a6d","gameinfo":"gameinfo_d1b90ac2b0c0ac32d140"};